import React from 'react';
import classNames from 'classnames';
import CustomerBasketDialogInner from './CustomerBasketDialogInner';

const CustomerBasketDialogWrapper = ({ visible, close, show, errors, loading, children }) => {
  return (
    <div
      className={classNames('moodboard-modal', 'moodboard-customers-basket-modal', {
        '-open': visible,
        '-large': false,
      })}
    >
      <div className="moodboard-modal_backdrop" onClick={() => close()} />
      <div className="moodboard-modal_dialog">
        <button className="moodboard-modal_close" onClick={() => close()} />
        {children}
      </div>
    </div>
  );
};

const CustomerBasketDialog = ({
  visible,
  errors,
  lineItemsGroups,
  loading,
  close,
  show,
  emptyText,
}) => {
  return (
    <CustomerBasketDialogWrapper visible={visible} close={close}>
      <CustomerBasketDialogInner
        visible={visible}
        close={close}
        show={show}
        lineItemsGroups={lineItemsGroups}
        errors={errors}
        loading={loading}
        emptyText={emptyText}
      />
    </CustomerBasketDialogWrapper>
  );
};

export default CustomerBasketDialog;



// WEBPACK FOOTER //
// ./app/javascript/design/routes/Moodboard/components/CustomerBasketDialog.js